export default __webpack_public_path__ + "static/media/england.7ce5e37d.webp";